import { render, staticRenderFns } from "./SideSheetVirtualColleague.vue?vue&type=template&id=d546dfba&"
import script from "./SideSheetVirtualColleague.vue?vue&type=script&lang=ts&"
export * from "./SideSheetVirtualColleague.vue?vue&type=script&lang=ts&"
import style0 from "./SideSheetVirtualColleague.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports